<template>
  <div class="tree-view-item">
    <div v-if="isObject(data)" class="tree-view-item-leaf">
      <div class="tree-view-item-node" @click.stop="toggleOpen()">
        <span
          :class="{opened: isOpen()}"
          v-if="!isRootObject(data)"
          class="tree-view-item-key tree-view-item-key-with-chevron"
        >
          {{getKey(data)}}
          <span
            class="tree-view-select-node-trigger"
            title="Copy node"
            @click.stop="emitNodeSelect"
            v-if="!allowCopyFromDepth || currentDepth >= allowCopyFromDepth"
          >
            <icon
              name="copy"
              :inverse="true"
              scale="0.8"
            />
          </span>

          <span
            class="tree-view-select-node-trigger"
            title="Copy node as array"
            @click.stop="emitNodeSelect($event, true)"
            v-if="!allowCopyFromDepth || currentDepth >= allowCopyFromDepth"
          >
            <icon
              name="list-ol"
              :inverse="true"
              scale="0.8"
            />
            <icon
              name="copy"
              :inverse="true"
              scale="0.8"
            />
          </span>
        </span>
        <span class="tree-view-item-hint" v-show="!isOpen() && data.children.length === 1">{{data.children.length}} property</span>
        <span class="tree-view-item-hint" v-show="!isOpen() && data.children.length !== 1">{{data.children.length}} properties</span>
      </div>
      <TreeViewItem
        :max-depth="maxDepth"
        :current-depth="currentDepth + 1"
        v-show="isOpen()"
        v-for="(child, idx) in data.children"
        :key="idx"
        :data="child"
        :allow-copy-from-depth="allowCopyFromDepth"
      />
    </div>
    <div v-if="isArray(data)" class="tree-view-item-leaf">
      <div class="tree-view-item-node" @click.stop="toggleOpen()">
        <span
          :class="{opened: isOpen()}"
          v-if="!isRootObject(data)"
          class="tree-view-item-key tree-view-item-key-with-chevron"
        >
          {{getKey(data)}}
          <span
            class="tree-view-select-node-trigger"
            title="Copy node"
            @click.stop="emitNodeSelect"
            v-if="!allowCopyFromDepth || currentDepth >= allowCopyFromDepth"
          >
            <icon
              name="copy"
              :inverse="true"
              scale="0.8"
            />
          </span>
        </span>

        <span
          class="tree-view-select-node-trigger"
          title="Copy node as array"
          @click.stop="emitNodeSelect($event, true)"
          v-if="!allowCopyFromDepth || currentDepth >= allowCopyFromDepth"
        >
          <icon
            name="list-ol"
            :inverse="true"
            scale="0.8"
          />
          <icon
            name="copy"
            :inverse="true"
            scale="0.8"
          />
        </span>
        <span class="tree-view-item-hint" v-show="!isOpen() && data.children.length === 1">{{data.children.length}} item</span>
        <span class="tree-view-item-hint" v-show="!isOpen() && data.children.length !== 1">{{data.children.length}} items</span>
      </div>
      <TreeViewItem
        :max-depth="maxDepth"
        :current-depth="currentDepth + 1"
        v-show="isOpen()"
        v-for="(child, idx) in data.children"
        :key="idx"
        :data="child"
        :allow-copy-from-depth="allowCopyFromDepth"
      />
    </div>
    <div class="tree-view-item-leaf" v-if="isValue(data)">
      <span class="tree-view-item-key">
        {{getKey(data)}}
        <span
          class="tree-view-select-node-trigger"
          title="Copy node"
          @click.stop="emitNodeSelect"
          v-if="!allowCopyFromDepth || currentDepth >= allowCopyFromDepth"
        >
          <icon
            name="copy"
            :inverse="true"
            scale="0.8"
          />
        </span>

        <span
          class="tree-view-select-node-trigger"
          title="Copy node as array"
          @click.stop="emitNodeSelect($event, true)"
          v-if="!allowCopyFromDepth || currentDepth >= allowCopyFromDepth"
        >
          <icon
            name="list-ol"
            :inverse="true"
            scale="0.8"
          />
          <icon
            name="copy"
            :inverse="true"
            scale="0.8"
          />
        </span>
      </span>
      <span class="tree-view-item-value">{{getValue(data)}}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'data',
    'max-depth',
    'current-depth',
    'allow-copy-from-depth'
  ],
  data () {
    return {
      open: this.currentDepth < this.maxDepth
    }
  },
  methods: {
    isOpen (){
      return this.isRootObject(this.data) || this.open
    },
    toggleOpen () {
      this.open = !this.open
    },
    isObject (value) {
      return value.type === 'object'
    },
    isArray (value) {
      return value.type === 'array'
    },
    isValue (value) {
      return value.type === 'value'
    },
    getKey (value) {
      if (Number.isInteger(value.key)) {
        return value.key+":";
      } else {
        return "\""+ value.key + "\":"
      }
    },
    getValue (value) {
      if (_.isNumber(value.value)) {
        return value.value
      }
      if (_.isNull(value.value)) {
        return "null"
      }
      if (_.isString(value.value)) {
        return `"${value.value}"`
      }
    },
    isRootObject (value) {
      return value.isRoot
    },
    emitNodeSelect (event, asArray) {
      const path = []

      for (let item of event.path) {
        if ($(item).hasClass('tree-view-wrapper')) break
        if ($(item).parent('.tree-view-item-node').length) continue
        if ($(item).find('> .tree-view-item-node').length) {
          const keyItem = $(item).find('> .tree-view-item-node > .tree-view-item-key')
          path.push(this.cropVal($(keyItem).text()))
        } else if ($(item).hasClass('tree-view-item-key')) {
          path.push(this.cropVal($(item).text()))
        }
      }

      if (!path[path.length]) path.splice(path.length - 1, 1)

      path.reverse()

      let parent = this.$parent

      while (!$(parent.$el).hasClass('tree-view-wrapper')) {
        parent = parent.$parent
      }

      parent.$data.eventBus.$emit('onSelect', path, asArray)
    },
    cropVal (val) {
      let newVal = val.trim()
      newVal = newVal.replace(/"|:/g, '')
      return newVal
    }
  }
}
</script>

<style lang="scss">
.tree-view {
  &-select-node-trigger {
    cursor: pointer;
    padding: 0 4px;
    background: #999;
    border-radius: 3px;
    border: 1px solid #ddd;
    svg {
      vertical-align: -2px;
    }
    &:hover {
      background: #bbb;
    }
  }
}
</style>
